import { Hidden, Theme, useMediaQuery } from "@material-ui/core";
import Skeleton from "@material-ui/core/Skeleton";
import Typography from "@material-ui/core/Typography";
import React from "react";
import numberFormat from "../../../../utils/formatNumber";
import { TodayFC } from "./types";

const Today: TodayFC = ({ isLoading, suffix, value = 0 }) => {
  let valueNode: React.ReactNode;
  if (isLoading) {
    valueNode = (
      <Skeleton width={30} height={37} sx={{ display: "inline-block" }} />
    );
  } else {
    valueNode = numberFormat(value, 0);
  }
  const isDisplaySmall = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("md")
  );
  return (
    <>
      <Hidden lgDown>
        <Typography variant={"subtitle2"}>сегодня</Typography>
      </Hidden>
      <Typography
        component={"span"}
        variant={isDisplaySmall ? "h2" : "h1"}
        color={"primary"}
        sx={{ position: "relative" }}
      >
        {valueNode}
        <Typography
          component={"span"}
          sx={{ marginLeft: 0.5, position: "absolute", bottom: 0 }}
          variant={"subtitle2"}
        >
          {suffix ?? ""}
        </Typography>
      </Typography>
    </>
  );
};

export default Today;
